window.lang2 = 
{
  "general": {
    "accessibility": {
      "skip_to_content": "Direkt zum Inhalt",
      "close_modal": "Schließen",
      "link_messages": {
        "new_window": "Öffnet ein neues Fenster.",
        "external": "Öffnet externe Webseite.",
        "new_window_and_external": "Öffnet externe Webseite in einem neuen Fenster."
      },
      "refresh_page": "Wenn Sie eine Auswahl auswählen, wird eine vollständige Seite aktualisiert",
      "selection_help": "drücken Sie die Leertaste und dann die Pfeiltasten, um eine Auswahl zu treffen"
    },
    "meta": {
      "tags": "Getaggt \"{{ tags }}\"",
      "page": "Seite {{ page }}"
    },
    "404": {
      "title": "404 Seite nicht gefunden",
      "subtext": "Die von Ihnen angeforderte Seite existiert nicht.",
      "link": "Einkauf fortzusetzen"
    },
    "pagination": {
      "previous": "Vorherige Seite",
      "next": "Nächste Seite",
      "current_page": "Seite {{ current }} von {{ total }}"
    },
    "password_page": {
      "opening_soon": "Eröffnet demnächst",
      "login_form_heading": "Shop mit Passwort betreten",
      "login_form_password_label": "Passwort",
      "login_form_password_placeholder": "Ihr Passwort",
      "login_form_submit": "Betreten",
      "signup_form_email_label": "E-Mail",
      "signup_form_success": "Wir senden Ihnen eine E-Mail, kurz bevor wir eröffnen!",
      "admin_link_html": "Sind Sie der Geschäftsinhaber? <a href=\"\/admin\" class=\"text-link\">Melden Sie sich hier an<\/a>",
      "password_link": "Mit Passwort betreten",
      "powered_by_shopify_html": "Dieser Shop wird mit Hilfe von {{ shopify }} betrieben werden"
    },
    "social": {
      "share_on_facebook": "Teilen",
      "share_on_twitter": "Twittern",
      "share_on_pinterest": "Pinnen",
      "alt_text": {
        "share_on_facebook": "Auf Facebook teilen",
        "share_on_twitter": "Auf Twitter twittern",
        "share_on_pinterest": "Auf Pinterest pinnen"
      }
    },
    "search": {
      "no_results_html": "Bitte versuchen Sie einen anderen Suchbegriff oder gehen Sie zurück zur <a href=\"\/\">Startseite<\/a>.",
      "empty_search_message": "Suchfeld darf nicht leer sein",
      "results_with_count": {
        "one": "{{ count }} Ergebnis für \"{{ terms }}\"",
        "other": "{{ count }} Ergebnisse für \"{{ terms }}\""
      },
      "title": "Suchen Sie auf unserer Seite",
      "placeholder": "Suchen...",
      "submit": "Suchen",
      "close": "Schließen (esc)",
      "no_results": "Keine Ergebnisse",
      "view_results": "Alle Ergebnisse anzeigen",
      "heading": {
        "one": "Suchergebnis",
        "other": "Suchergebnisse"
      }
    },
    "newsletter_form": {
      "newsletter_email": "Abonnieren Sie unsere Mailingliste",
      "email_placeholder": "E-Mail-Adresse",
      "confirmation": "Danke für Ihre Anmeldung!",
      "submit": "Abonnieren"
    },
    "filters": {
      "show_more": "Mehr anzeigen",
      "show_less": "Weniger anzeigen"
    },
    "payment": {
      "method": "Zahlungsarten"
    },
    "currency": {
      "dropdown_label": "Währung"
    }
  },
  "sections": {
    "slideshow": {
      "next_slide": "Nächster Schieber",
      "previous_slide": "Vorheriger Schieber",
      "pause_slideshow": "Diashow pausieren",
      "rotate_slideshow": "Diashow abspielen",
      "load_slide": "Folie {{ slide_number }} laden",
      "navigation_instructions": "Nutzen Sie die linken\/rechten Pfeile, um durch die Slideshow zu navigieren, oder wischen Sie nach links bzw. rechts, wenn Sie ein mobiles Gerät verwenden"
    },
    "featured_product": {
      "title": "Vorgestelltes Produkt",
      "gallery_thumbnail_alt": "Laden Sie das Bild in den Galerie-Viewer, {{ imageAlt }}"
    },
    "map": {
      "address_error": "Kann die Adresse nicht finden",
      "address_no_results": "Keine Ergebnisse für diese Adresse",
      "address_query_limit_html": "Sie haben die Google- API-Nutzungsgrenze überschritten. Betrachten wir zu einem <a href=\"https:\/\/developers.google.com\/maps\/premium\/usage-limits\">Premium-Paket<\/a> zu aktualisieren.",
      "auth_error_html": "Es gab ein Problem bei der Authentifizierung Ihres Google Maps-Kontos.",
      "section_heading": "Lage"
    },
    "video": {
      "play": "Video abspielen",
      "pause": "Video pausieren",
      "resume": "Video fortsetzen",
      "close": "Video schliessen"
    }
  },
  "blogs": {
    "article": {
      "view_all": "Alle anzeigen",
      "view_all_blogs": "Alle anzeigen Artikel",
      "all_topics": "Alle themen",
      "by_author": "von {{ author }}",
      "posted_in": "Veröffentlicht in",
      "read_more": "Weiterlesen",
      "read_more_title": "Weiterlesen: {{ title }}",
      "back_to_blog": "Zurück zu {{ title }}",
      "tags": "Stichworte"
    },
    "comments": {
      "title": "Hinterlassen Sie einen Kommentar",
      "name": "Name",
      "email": "E-Mail",
      "message": "Nachricht",
      "post": "Kommentar posten",
      "moderated": "Bitte beachten Sie, dass Kommentare vor der Veröffentlichung freigegeben werden müssen",
      "success_moderated": "Ihr Kommentar wurde erfolgreich gepostet. Da unser Blog moderiert wird, werden wir ihn erst kurze Zeit später veröffentlichen.",
      "success": "Ihr Kommentar wurde erfolgreich gepostet. Danke!",
      "unapproved": "Die angegebene E-Mail-Adresse ist nicht zum Posten von Kommentaren freigegeben.",
      "comments_with_count": {
        "one": "{{ count }} Kommentar",
        "other": "{{ count }} Kommentare"
      }
    }
  },
  "cart": {
    "general": {
      "title": "Meine Tasche",
      "remove": "Entfernen",
      "note": "Besondere Hinweise an den Verkäufer",
      "subtotal": "Zwischensumme",
      "shipping_at_checkout": "Liefer- und Preisnachlässe an der Kasse berechnet",
      "update": "Einkaufswagen aktualisieren",
      "checkout": "Zur Kasse",
      "empty": "Ihr Einkaufswagen ist im Moment leer.",
      "continue_browsing_html": "Mit der Suche <a href=\"\/collections\/all\">hier<\/a> fortfahren.",
      "view_cart": "Einkaufswagen ansehen",
      "close_cart": "Einkaufswagen schließen",
      "shopping_cart": "Meine Tasche",
      "button_checkout": "Zur Kasse gehen",
      "free_shipping_message_1": "Sie Qualität für freies Verschiffen!",
      "free_shipping_message_2": "Sie sind",
      "free_shipping_message_3": "keine versandkosten!",
      "continue_shopping": "Weiter Warenkorb",
      "go_to_cart": "Zum Warenkorb",
      "label": "hinweis",
      "order_summary": "Order Summary",
      "label_text": "Zusätzliche Bemerkungen",
      "shipping_calculator_button": "Berechnen Versandkosten",
      "shipping_calculator_calculating": "Berechnung...",
      "shipping_calculator_error_message": "Fehler: Bitte geben Sie rechts Versandinformationen",
      "shipping_calculator_success_many_rates": {
        "there_are": "Es gibt",
        "shipping_rates_available_for": "Versandkosten für ",
        "starting_at": ", beginnend bei "
      },
      "shipping_calculator_success_one_rate": "Es gibt eine Versandkostenpauschale für die zur Verfügung",
      "shipping_calculator_success_no_rate": "Es gibt keine Versandkostenpauschale zu dieser Bestellung und Ziel zur Verfügung.",
      "shipping_calculator_success_at": "bei"
    },
    "label": {
      "product": "Artikel",
      "price": "Preis",
      "quantity": "Menge",
      "total": "Gesamt",
      "or": "oder"
    },
    "ajax_cart": {
      "continue_shopping": "Weiter Warenkorb",
      "go_to_cart": "Zum Warenkorb",
      "success_text": "Wird in den Warenkorb gelegt.",
      "error": "Fehler",
      "loading": "Wird Geladen",
      "close": "Wird Geladen"
    }
  },
  "collections": {
    "general": {
      "view_all": "Alle anzeigen",
      "view_all_label": "Sehen Sie alle Produkte in der {{ collection_name }}-Sammlung",
      "no_matches": "Es tut uns leid, aber Ihre Suche nach Produkten hat keine Treffer ergeben.",
      "show_more": "Zeig mehr",
      "no_more_product": "Keine weitere Produkt-",
      "compare_selected": "Ausgewählte vergleichen",
      "items_with_count": {
        "one": "{{ count }} Produkt",
        "other": "{{ count }} Produkte"
      },
      "collection_label": "Sammlung",
      "shop_the_collection": "Sammlung anzeigen"
    },
    "sorting": {
      "title": "Sortieren nach",
      "featured": "Ausgewählt",
      "best_selling": "Meistverkauft",
      "az": "Alphabetisch, A-Z",
      "za": "Alphabetisch, Z-A",
      "price_ascending": "Preis, niedrig nach hoch",
      "price_descending": "Preis, hoch nach niedrig",
      "date_descending": "Datum, neu nach alt",
      "date_ascending": "Datum, alt nach neu"
    },
    "sidebar": {
      "types": "Produktart",
      "vendors": "Verkäufer",
      "tags": "Tags",
      "clear": "Klar",
      "clear_all": "Löschen",
      "refined_by": "Sortiert nach",
      "sidebar_more": "Einkaufen nach"
    },
    "toolbar": {
      "view_as": "Ansicht als",
      "item_per_page": "Reihen per Seite",
      "previous": "Vorheriger",
      "next": "Nächster",
      "show": "Show",
      "all": "Alle",
      "showing": "Zeige",
      "of": "von"
    },
    "filters": {
      "title_tags": "Filtern nach",
      "all_tags": "Alle Produkte"
    }
  },
  "contact": {
    "form": {
      "title": "Kontaktiere uns",
      "name": "Name",
      "email": "E-Mail",
      "phone": "Telefonnummer",
      "message": "Nachricht",
      "submit": "Absenden",
      "submit_contact": "Kontakt einreichen",
      "send_question": "Frage senden",
      "add_customize": "Hinzufügen Anpassen",
      "post_success": "Danke, dass Sie uns kontaktiert haben. Wir werden uns so schnell wie möglich bei Ihnen melden.",
      "error_heading": "Bitte passen Sie Folgendes an:"
    }
  },
  "customer": {
    "account": {
      "title": "Konto",
      "details": "Kontodetails",
      "view_addresses": "Adressen ansehen",
      "return": "Zurück zu Kontodetails"
    },
    "activate_account": {
      "title": "Konto aktivieren",
      "subtext": "Erstellen Sie ein Passwort, um Ihr Konto zu aktiveren.",
      "password": "Passwort",
      "password_confirm": "Passwort bestätigen",
      "submit": "Konto aktivieren",
      "cancel": "Einladung ablehnen"
    },
    "addresses": {
      "title": "Ihre Adressen",
      "default": "Standard",
      "add_new": "Neue Adresse hinzufügen",
      "edit_address": "Adresse bearbeiten",
      "first_name": "Vorname",
      "last_name": "Nachname",
      "company": "Firma",
      "address1": "Adresse",
      "address2": "Wohnung, Zimmer usw.",
      "city": "Stadt",
      "country": "Land",
      "province": "Bundesland",
      "zip": "PLZ",
      "phone": "Telefon",
      "set_default": "Als Standard-Adresse festlegen",
      "add": "Adresse hinzufügen",
      "update": "Adresse aktualisieren",
      "cancel": "Abbrechen",
      "edit": "Bearbeiten",
      "delete": "Löschen",
      "delete_confirm": "Sind Sie sicher, dass Sie diese Adresse löschen möchten?"
    },
    "login": {
      "title": "Login",
      "email": "E-Mail",
      "password": "Passwort",
      "forgot_password": "Haben Sie Ihr Passwort vergessen?",
      "sign_in": "Anmelden",
      "guest_title": "Als Gast fortsetzen",
      "guest_continue": "Fortsetzen",
      "account": "Konto",
      "account": "Konto",
      "returning_customer": "Returning Customer",
      "login": "Login",
      "cancel": "Zurück zum Shop",
      "new_customer": "New Customer"
    },
    "orders": {
      "title": "Bestellungen",
      "order_number": "Bestellung",
      "order_number_link": "Bestellnummer {{ number }}",
      "date": "Datum",
      "payment_status": "Zahlungsstatus",
      "fulfillment_status": "Lieferstatus",
      "total": "Gesamt",
      "none": "Sie haben noch keine Bestellungen aufgegeben."
    },
    "order": {
      "title": "Bestellung {{ name }}",
      "date_html": "Aufgegeben am {{ date }}",
      "cancelled_html": "Bestellung storniert am {{ date }}",
      "cancelled_reason": "Grund: {{ reason }}",
      "billing_address": "Rechnungsadresse",
      "payment_status": "Zahlungsstatus",
      "shipping_address": "Lieferadresse",
      "fulfillment_status": "Lieferstatus",
      "discount": "Rabatt",
      "shipping": "Versand",
      "tax": "Steuern",
      "product": "Artikel",
      "sku": "SKU",
      "price": "Preis",
      "quantity": "Menge",
      "total": "Gesamt",
      "fulfilled_at_html": "Geliefert am {{ date }}",
      "subtotal": "Zwischensumme",
      "track_shipment": "Sendung verfolgen"
    },
    "recover_password": {
      "title": "Passwort zurücksetzen",
      "email": "E-Mail",
      "submit": "Absenden",
      "cancel": "Abbrechen",
      "subtext": "Wir werden Ihnen eine E-Mail zum Zurücksetzen des Passworts schicken.",
      "success": "Wir haben Ihnen eine E-Mail mit einem Link zum Aktualisieren des Passworts geschickt."
    },
    "reset_password": {
      "title": "Passwort für Konto zurücksetzen",
      "subtext": "Geben Sie ein neues Passwort für {{ email }} ein",
      "password": "Passwort",
      "password_confirm": "Passwort bestätigen",
      "submit": "Passwort zurücksetzen"
    },
    "register": {
      "title": "Konto erstellen",
      "first_name": "Vorname",
      "last_name": "Nachname",
      "email": "E-Mail",
      "password": "Passwort",
      "submit": "Erstellen"
    }
  },
  "homepage": {
    "onboarding": {
      "product_title": "Der Name Ihres Produkts",
      "product_description": "Diesen Abschnitt können Sie nutzen, um die Details Ihres Produkts zu beschreiben. Erzählen Sie den Kunden, wie Ihr Produkt aussieht, sich anfühlt und designt ist. Fügen Sie Einzelheiten zu Farbe, verwendeten Materialien, Größe und Produktionsort hinzu.",
      "collection_title": "Der Name Ihrer Kollektion",
      "blog_title": "Der Titel Ihres Posts",
      "blog_excerpt": "Ihr Laden hat noch keine Blogposts veröffentlicht. Ein Blog kann genutzt werden, um über die Einführung neuer Produkte, Tipps oder andere Neuigkeiten, die Sie mit Ihren Kunden teilen möchten, zu berichten. Für Inspiration und Ratschläge für Ihren eigenen Laden und Blog können Sie den E-Commerce-Blog von Shopify besuchen.",
      "blog_author": "Name des Autors",
      "no_content": "Dieser Bereich hat zur Zeit keinen Inhalt. Füge diesem Bereich über die Seitenleiste Inhalte hinzu."
    }
  },
  "layout": {
    "navigation": {
      "search": "Suchen",
      "expand": "ausklappen",
      "collapse": "einklappen",
      "menu": "Menü"
    },
    "cart": {
      "title": "Einkaufswagen",
      "items_count": {
        "one": "Produkt",
        "other": "Produkte"
      }
    },
    "customer": {
      "account": "Konto",
      "log_out": "Ausloggen",
      "log_in": "Einloggen",
      "create_account": "Konto erstellen"
    },
    "footer": {
      "social_platform": "{{ name }} auf {{ platform }}"
    }
  },
  "products": {
    "product": {
      "regular_price": "Normaler Preis",
      "sold_out": "Ausverkauft",
      "new": "Neu",
      "unavailable": "Nicht verfügbar",
      "sale": "Angebot",
      "sale_price": "Sonderpreis",
      "quantity": "Menge",
      "add_to_cart": "In den Einkaufswagen legen",
      "add_to_cart_custom": "Hinzufügen+",
      "add": "Hinzufügen",
      "select_options": "wähle Optionen",
      "quick_view": "Schnellansicht",
      "in_stock": "Auf Lager",
      "out_of_stock": "Ausverkauft",
      "details": "Einzelheiten",
      "back_to_collection": "Zurück zu {{ title }}",
      "from": "von ",
      "vendor": "Verkäufer",
      "quantity_minimum_message": "Die Menge muss 1 oder mehr sein",
      "include_taxes": "inkl. MwSt.",
      "shipping_policy_html": "zzgl. <a href=\"{{ link }}\">Versandkosten<\/a>"
    }
  },
  "gift_cards": {
    "issued": {
      "title_html": "Hier ist Ihre {{ value }} Geschenkkarte für {{ shop }}!",
      "subtext": "Hier ist Ihre Geschenkkarte!",
      "gift_card_code": "Gutscheincode",
      "disabled": "Deaktiviert",
      "expired": "Abgelaufen am {{ expiry }}",
      "active": "Läuft ab am {{ expiry }}",
      "redeem_html": "Nutzen Sie an der Kasse diesen Code, um Ihre {{ value }} Geschenkkarte einzulösen",
      "shop_link": "Einkauf beginnen",
      "print": "Diesen Geschenkgutschein ausdrucken",
      "remaining_html": "{{ balance }} übrig",
      "add_to_apple_wallet": "Hinzufügen zu Apple Wallet",
      "qr_image_alt": "QR-Code - Scannen, um Geschenkkarte einzulösen"
    }
  },
  "date_formats": {
    "month_day_year": "%-d. %b %Y"
  },
  "wishlist": {
    "general": {
      "my_wishlist": "My Wishlists",
      "wishlist": "Wish Lists",
      "product_image": "Image",
      "product_name": "Product Name",
      "unit_price": "Unit Price",
      "share_wishlist": "Share my Wishlist Via Email",
      "no_login_html": "To create a wish list you must <a href=\"\/account\/login\">sign in<\/a> or <a href=\"\/account\/register\">create an account<\/a>.",
      "add_to_wishlist": "Add to Wish List",
      "remove_wishlist": "Remove Wish List",
      "note": "Already in your wishlist, Go to wishlist",
      "subtext": "To create a wish list you must",
      "sign_in": "sign in",
      "or": "or",
      "wishlist_empty": "Looks like you haven't started a wishlist yet...",
      "create_account": "create an account"
    }
  },
  "compare": {
    "general": {
      "title": "Vergleichen Sie",
      "add_to_compare": "Vergleichen Sie",
      "remove_compare": "Entfernen Sie Compare",
      "remove_all": "Alles entfernen",
      "product": "Produkte",
      "review": "Bewertung",
      "description": "Beschreibung",
      "collection": "Sammlung",
      "availability": "Verfügbarkeit",
      "product_type": "Produktart",
      "sku": "SKU",
      "size": "Größe",
      "color": "Farbe",
      "option": "Möglichkeit",
      "message": "Sie müssen mindestens zwei Produkte zum Vergleich auswählen!"
    }
  }
}